import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'
import type { ChannelMiniEntity } from '@/features/channel/domain/entities/ChannelMiniEntity'
import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'
import type { CouponTranslationEntity } from './CouponTranslationEntity'
import type { CouponOnItemDeliveryEntity } from './CouponOnItemDeliveryEntity'
import type { UserGroupEntity } from '@/features/userGroup/domain/entities/UserGroupEntity'
import type { CouponRegionEntity } from './CouponRegionEntity'
import type { FileUploadEntity } from '@/shared/entities/FileUploadEntity'
export class CreateCouponEntity {
  redeemCode?: string | null
  onItem?: CouponOnItemDeliveryEntity
  onDelivery?: CouponOnItemDeliveryEntity
  validFrom?: string
  validTo?: string
  maxUsageCount?: number | null
  maxUsagePerUser?: number | null
  minCartAmount?: number
  isActive?: boolean
  hidden?: boolean
  users?: UserMiniEntity[]
  groups?: UserGroupEntity[]
  branches?: BranchMiniEntity[]
  regions?: CouponRegionEntity[]
  channels?: ChannelMiniEntity[]
  translations?: CouponTranslationEntity[]
  canBeAppliedWithCampaign?: boolean
  image?: FileUploadEntity
  imageUrl?: string | null
}
